import React, { createContext, useContext, useEffect, useState } from 'react';
import tr from './tr';
import en from './en';

const DICTS = { tr, en };
const LanguageContext = createContext(null);

function detectDefaultLang() {
  try {
    const stored = localStorage.getItem('ts_lang');
    if (stored === 'tr' || stored === 'en') return stored;
  } catch (_) { /* localStorage erişilemez (gizli sekme vb.) — sessizce yoksay */ }
  const nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
  return nav.startsWith('en') ? 'en' : 'tr';
}

function lookup(dict, path) {
  return path.split('.').reduce((o, k) => (o == null ? undefined : o[k]), dict);
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectDefaultLang);

  useEffect(() => {
    document.documentElement.lang = lang;
    try { localStorage.setItem('ts_lang', lang); } catch (_) { /* yoksay */ }
  }, [lang]);

  const setLang = (l) => setLangState(l === 'en' ? 'en' : 'tr');

  // path: "namespace.key" (nokta-yollu). Aktif dilde anahtar yoksa TR'ye düşer (sessizce kırılmasın
  // diye); TR'de de yoksa anahtarın kendisi döner (geliştirme sırasında eksik çeviri fark edilsin diye).
  const t = (path, vars) => {
    let str = lookup(DICTS[lang], path);
    if (str == null) str = lookup(DICTS.tr, path);
    if (str == null) return path;
    if (vars) {
      for (const [k, v] of Object.entries(vars)) str = str.split(`{${k}}`).join(v);
    }
    return str;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useTranslation, LanguageProvider içinde kullanılmalı');
  return ctx;
}
